import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { User } from "../user";
import { UserService } from "../user.service";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class UserResolver  {
  constructor(private userService: UserService) {}
 
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any>|Promise<any>|any {
    return this.userService.getProfileOfUser(route.params.user);
  }
}
